import { baseStoreCreator } from '@/utils/store';

export interface AccountFundingParamsPayload {
  omnibus: string;
  accountCreation: string;
  
  isForfeitAllowed: boolean,
  forfeitureDays: string,
  
  replenishmentBankAccount: string;
  replenishmentMethod: string;
  replenishmentFrequency: string;
  replenishmentDayNumber: string;
  
  contributionBankAccount: string;
  contributionMethod: string;
  contributionHoldPeriod?: string;
  contributionPushGiveUpDays?: string;
  
  //TODO: need to remove after new funding fields implementation (after remove FF from UI)
  isReplenished: boolean;
  planLevelFunding: boolean;
  isPreFundCalculated?: boolean;

  replenishmentPercent?: number;
  replenishmentMinValue?: string;
  replenishmentCreepPercent?: number;
  replenishmentCreepMin?: string;

  isParticipantPaidMaintenanceFee: boolean;
  maintenanceFee?: string;
  applyFeeTo?: string;
  cashBalanceThreshold?: string;
  fundingMethod?: string | null;
  eoyPlanReconciliation: string;
  eoyPlanReconciliationDelayDays: string;

  // Plan level funding fields
  billingMethodTypeId?: string;
  externalBankAccount?: string;
  externalPushReturnAccount?: string;
}

export const DEFAULT_VALUES: AccountFundingParamsPayload = {
  isReplenished: false,
  planLevelFunding: false,
  replenishmentBankAccount: '',
  replenishmentMethod: '',
  replenishmentFrequency: '',
  replenishmentDayNumber: '',

  contributionBankAccount: '',
  contributionMethod: '',
  contributionHoldPeriod: '',
  contributionPushGiveUpDays: '',

  omnibus: '',
  accountCreation: '',

  isForfeitAllowed: false,
  forfeitureDays: '',

  isPreFundCalculated: false,
  replenishmentPercent: undefined,
  replenishmentMinValue: undefined,
  replenishmentCreepPercent: undefined,
  replenishmentCreepMin: undefined,

  isParticipantPaidMaintenanceFee: false,
  maintenanceFee: undefined,
  applyFeeTo: undefined,
  cashBalanceThreshold: undefined,
  fundingMethod: undefined,
  eoyPlanReconciliation: '',
  eoyPlanReconciliationDelayDays: '15',

  billingMethodTypeId: undefined,
  externalBankAccount: undefined,
  externalPushReturnAccount: undefined,
};

export const useStore = baseStoreCreator<AccountFundingParamsPayload>(DEFAULT_VALUES);

export default useStore;
